// removed by extract-text-webpack-plugin
module.exports = {"container":"_4swfy18rpquueqnvhbhtkbkkvp5r7bmjcag79th97s11855q94j74sfn7guhxcy2fthnmpaskw1nakfjzuq8p8affcyqdsknkge4g4z-Grid-module-container"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grid/Grid.module.css
// module id = 142
// module chunks = 0